<template>
    <div>
        <Separator :label="$t('page.description')"></Separator>
        <div class="container-fluid__with-padding">
            <div class="row justify-content-center">
                <div class="col-lg-6 col-md-8 col-12 description" v-html="description">
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import Separator from './Separator'
    import marked from 'marked'

    export default {
        name: "Description",
        components: {
            Separator
        },
        props: {
            description : null
        },
    }
</script>

